// extracted by mini-css-extract-plugin
export var deleteModal = "_qs-0";